var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0C7.17761 0 0 7.1775 0 15.9999C0 24.8223 7.17761 31.9998 16.0001 31.9998C24.8225 31.9998 32 24.8223 32 15.9999C32 7.1775 24.8225 0 16.0001 0ZM16.0001 29.3769C8.62389 29.3769 2.62293 23.3761 2.62293 15.9999C2.62293 8.62379 8.62389 2.62293 16.0001 2.62293C23.3762 2.62293 29.3771 8.62379 29.3771 15.9999C29.3771 23.3761 23.3762 29.3769 16.0001 29.3769Z",
    fill: "green"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9216 9.85916L13.4218 19.3591L9.0784 15.0157C8.5662 14.5036 7.73588 14.5036 7.22368 15.0157C6.71157 15.5279 6.71157 16.3583 7.22368 16.8705L12.4944 22.1412C12.7505 22.3972 13.0861 22.5253 13.4218 22.5253C13.7574 22.5253 14.093 22.3972 14.3491 22.1412L24.7763 11.714C25.2884 11.2018 25.2884 10.3715 24.7763 9.85927C24.2641 9.34706 23.4337 9.34706 22.9216 9.85916Z",
    fill: "green"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.3692ad118406945626429e3d326d631f.svg";
export { ForwardRef as ReactComponent };